"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.calculateInitialState = exports.getItemsInSlide = exports.getIsStageContentPartial = exports.concatClassnames = exports.canUseDOM = void 0;

var elements_1 = require("./elements"),
    math_1 = require("./math");

exports.canUseDOM = function () {
  var t;

  try {
    return Boolean(null == (t = null === window || void 0 === window ? void 0 : window.document) ? void 0 : t.createElement);
  } catch (t) {
    return !1;
  }
}, exports.concatClassnames = function () {
  for (var t = [], e = 0; e < arguments.length; e++) {
    t[e] = arguments[e];
  }

  return t.filter(Boolean).join(" ");
}, exports.getIsStageContentPartial = function (t, e, i) {
  return void 0 === e && (e = 0), void 0 === i && (i = 0), !(t = void 0 !== t && t) && i <= e;
}, exports.getItemsInSlide = function (e, t) {
  var i,
      n = 1,
      o = t.responsive,
      a = t.autoWidth,
      s = t.infinite,
      t = t.innerWidth;
  return void 0 !== a && a ? void 0 !== s && s ? e : n : (o && (a = Object.keys(o)).length && (t || exports.canUseDOM()) && (i = t || window.innerWidth, a.forEach(function (t) {
    Number(t) < i && (n = Math.min(o[t].items, e) || n);
  })), n);
}, exports.calculateInitialState = function (t, e, i) {
  void 0 === i && (i = !1);
  var n,
      o,
      a = t.animationDuration,
      a = void 0 === a ? 0 : a,
      s = t.infinite,
      s = void 0 !== s && s,
      r = t.autoPlay,
      r = void 0 !== r && r,
      l = t.autoWidth,
      l = void 0 !== l && l,
      m = elements_1.createClones(t),
      d = elements_1.getTransitionProperty(),
      u = elements_1.getItemsCount(t),
      c = elements_1.getItemsOffset(t),
      f = exports.getItemsInSlide(u, t),
      p = math_1.getStartIndex(t.activeIndex, u),
      p = math_1.getActiveIndex({
    startIndex: p,
    itemsCount: u,
    infinite: s
  }),
      g = elements_1.getElementDimensions(e).width,
      h = (o = (e = l ? (n = (e = elements_1.createAutowidthTransformationSet(e, g, s)).coords, o = e.content, e.partial) : (n = (e = elements_1.createDefaultTransformationSet(m, g, f, s)).coords, o = e.content, e.partial), o), math_1.getItemCoords(-f, n = n).position),
      v = math_1.getSwipeLimitMin({
    itemsOffset: c,
    transformationSet: n
  }, t),
      t = math_1.getSwipeLimitMax({
    itemsCount: u,
    itemsOffset: c,
    itemsInSlide: f,
    transformationSet: n
  }, t),
      S = math_1.getSwipeShiftValue(u, n);
  return {
    activeIndex: p,
    autoWidth: l,
    animationDuration: a,
    clones: m,
    infinite: s,
    itemsCount: u,
    itemsInSlide: f,
    itemsOffset: c,
    translate3d: elements_1.getTranslate3dProperty(p, {
      itemsInSlide: f,
      itemsOffset: c,
      transformationSet: n,
      autoWidth: l,
      infinite: s
    }),
    stageWidth: g,
    stageContentWidth: o,
    initialStageHeight: 0,
    isStageContentPartial: e,
    isAutoPlaying: Boolean(r),
    isAutoPlayCanceledOnAction: !1,
    transformationSet: n,
    transition: d,
    fadeoutAnimationIndex: null,
    fadeoutAnimationPosition: null,
    fadeoutAnimationProcessing: !1,
    swipeLimitMin: v,
    swipeLimitMax: t,
    swipeAllowedPositionMax: h,
    swipeShiftValue: S,
    canUseDom: i || exports.canUseDOM()
  };
};